var _rect, _g, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 27.7267,
    height: 25.5019,
    rx: 1,
    transform: "matrix(0.989728 -0.142962 0.139593 0.990209 7.5 11.4639)",
    fill: "url(#paint0_linear_11184_60436)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_11184_60436)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.6875,
    y: 13.4471,
    width: 26.8125,
    height: 25.0529,
    rx: 1,
    fill: "url(#paint1_linear_11184_60436)"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17.8125,
    y: 17.6226,
    width: 5.15624,
    height: 5.21935,
    rx: 1,
    fill: "url(#paint2_linear_11184_60436)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 17.8125,
    y: 28.0613,
    width: 5.15624,
    height: 5.21935,
    rx: 1,
    fill: "url(#paint3_linear_11184_60436)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 25.0312,
    y: 17.6226,
    width: 11.4583,
    height: 1.73978,
    rx: 0.5,
    fill: "url(#paint4_linear_11184_60436)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 25.0312,
    y: 28.0613,
    width: 11.4583,
    height: 1.73978,
    rx: 0.5,
    fill: "url(#paint5_linear_11184_60436)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 25.0312,
    y: 20.7543,
    width: 6.87499,
    height: 1.73978,
    rx: 0.5,
    fill: "url(#paint6_linear_11184_60436)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 25.0312,
    y: 31.1929,
    width: 6.87499,
    height: 1.73978,
    rx: 0.5,
    fill: "url(#paint7_linear_11184_60436)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_11184_60436",
    x: 12.1875,
    y: 12.9471,
    width: 28.8125,
    height: 27.0529,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.5,
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11184_60436"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11184_60436",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11184_60436",
    x1: 13.8634,
    y1: 0,
    x2: 13.8634,
    y2: 25.5019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DEEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1FF5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11184_60436",
    x1: 27.0937,
    y1: 13.4471,
    x2: 27.0937,
    y2: 38.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F16BF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E47EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_11184_60436",
    x1: 19.0446,
    y1: 17.5167,
    x2: 21.6009,
    y2: 22.8178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4FFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_11184_60436",
    x1: 19.0446,
    y1: 27.9554,
    x2: 21.6009,
    y2: 33.2565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4FFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_11184_60436",
    x1: 27.7693,
    y1: 17.5873,
    x2: 27.926,
    y2: 19.7538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4FFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_11184_60436",
    x1: 27.7693,
    y1: 28.026,
    x2: 27.926,
    y2: 30.1926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4FFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_11184_60436",
    x1: 26.6741,
    y1: 20.719,
    x2: 26.9328,
    y2: 22.8657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4FFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_11184_60436",
    x1: 26.6741,
    y1: 31.1576,
    x2: 26.9328,
    y2: 33.3043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4FFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.9
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/게시판.938b4b5068775cd224009f110c025f43.svg";
export { ForwardRef as ReactComponent };